import {DatePicker} from '@material-ui/pickers';
import {EmptyDate} from 'Core/models/DateRange';
import * as Luxon from 'luxon';
import React from 'react';
import './DateFilter.sass';

type DateFilterProps = {
  startValue: Date | EmptyDate;
  endValue: Date | EmptyDate;
  onChangeStartDate: (value: string) => any;
  onChangeEndDate: (value: string) => any;
};

const DateFilter = (props: DateFilterProps) => {
  return (
    <div className="date-filter">
      <DatePicker
        clearable
        label="Start Date"
        format="MMMM d, yyyy"
        className="date-filter__input"
        value={props.startValue || null}
        shouldDisableDate={date => {
          return !props.endValue || !date ? false : date > Luxon.DateTime.fromJSDate(props.endValue);
        }}
        onChange={date => props.onChangeStartDate(date ? (date as Luxon.DateTime).startOf('day').toISO() : '')}
      />
      <DatePicker
        clearable
        label="End Date"
        className="date-filter__input"
        format="MMMM d, yyyy"
        shouldDisableDate={date => {
          return !props.startValue || !date ? false : date < Luxon.DateTime.fromJSDate(props.startValue);
        }}
        value={props.endValue || null}
        onChange={date => props.onChangeEndDate(date ? (date as Luxon.DateTime).endOf('day').toISO() : '')}
      />
    </div>
  );
};

export default DateFilter;
